<template>
  <NoteForm :note="note" :onSubmit="submit"></NoteForm>
</template>

<script>
import NoteForm from './Note-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'EditNote',
  components: {
    NoteForm,
  },
  created() {
    this.$store.dispatch('notes/getNote', {
      clientId: this.$route.params.clientId,
      noteId: this.$route.params.noteId,
    });
  },
  computed: {
    note() {
      return this.$store.state.notes.note;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('notes/updateNote', {
        clientId: this.$route.params.clientId,
        noteId: this.$route.params.noteId,
        body: this.note,
      })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
          this.$router.push({ path: `/clients/${this.$route.params.clientId}/notes/` });
        });
    },
  },
};
</script>
